import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ConversionTracking } from "../../components/ConversionTracking/ConversionTracking";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const ConversionTrackingPage = () => {
    return (
        <Page title="Conversion Tracking">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Marketing</Breadcrumb.Item>
                        <Breadcrumb.Item>Conversion Tracking</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <ConversionTracking />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
